import React, { useState, useEffect } from 'react';
import { Alert } from '../../../ui/atoms';
import { useTranslation } from 'react-i18next';

const INPUT_CLASSES = "form-input-inset";

const AISettingsTab = ({ formData, setFormData, activeTab }) => {
  const { t } = useTranslation();
  // Use local state for better performance when typing
  const [localPromptValue, setLocalPromptValue] = useState('');
  
  // Synchronize local state with form data when tab becomes active
  useEffect(() => {
    if (activeTab === 'ai') {
      setLocalPromptValue(formData.assistant_prompt || '');
    }
  }, [activeTab, formData.assistant_prompt]);
  
  // Update main state with debounce
  const handlePromptChange = (e) => {
    const newValue = e.target.value;
    setLocalPromptValue(newValue);
    
    // Use debounce to avoid updating main state on every keystroke
    clearTimeout(window.promptUpdateTimeout);
    window.promptUpdateTimeout = setTimeout(() => {
      setFormData(prev => ({
        ...prev,
        assistant_prompt: newValue
      }));
    }, 300); // 300ms debounce
  };

  return (
    <div className="space-y-12">
      <div className="pb-12">
        <h2 className="text-3xl font-medium leading-7 text-gray-900">{t('userProfile.ai.title')}</h2>
        <p className="mt-4 text-sm leading-6 text-gray-600">
          {t('userProfile.ai.description')}
        </p>

        <div className="mt-10">
          <div>
            <textarea
              name="assistant_prompt"
              id="assistant_prompt"
              value={localPromptValue}
              onChange={handlePromptChange}
              rows={8}
              className={`${INPUT_CLASSES} w-full`}
              placeholder={t('userProfile.ai.placeholder')}
            />
          </div>
          <div className="mt-2 text-sm text-gray-500">
            {t('userProfile.ai.helperText')}
          </div>
          
          <Alert
            variant="neutral"
            message={t('userProfile.ai.alertMessage')}
            actionText={t('userProfile.ai.alertAction')}
            actionHref="/datasets"
          />
        </div>
      </div>
    </div>
  );
};

export default AISettingsTab; 